// ------------------ config (static)
/* eslint-disable-next-line no-unused-vars */
const CheckoutKR = (() => {
	// private var(s)
	const _cartconfig = {};
	const _coupons = {};

	// private method(s)
	const _constructor = () => {
		// console.log('Config is running');
	};

	_constructor();

	// output/public
	return {
		cartConfig: _cartconfig,
		coupons: _coupons
	};
})();
